import { render } from "./FormBroadcastRecipient.vue?vue&type=template&id=7c67b3cf&ts=true"
import script from "./FormBroadcastRecipient.vue?vue&type=script&lang=ts"
export * from "./FormBroadcastRecipient.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__